import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';


@Injectable()
export class CookieService {

  constructor(
    @Inject(DOCUMENT) private readonly document: Document
  ) { }

  public set(cookieStr: string): void {
    this.document.cookie = cookieStr;
  }

  public get(): string {
    return this.document.cookie;
  }

  public getCookie(cookieName: string): string | undefined {
    const nameSeparator = `${cookieName}=`;
    const cookies = this.get();
    if (cookies && typeof (cookies) === 'string') {
      const decodedCookie = decodeURIComponent(cookies);
      const cookiesArray = decodedCookie.split(';');
      for (let cookieItem of cookiesArray) {
        cookieItem = cookieItem.trim();
        if (cookieItem.indexOf(nameSeparator) === 0) {
          return cookieItem.substring(nameSeparator.length, cookieItem.length);
        }
      }
    }

    return undefined;
  }

}
